import event1 from '../assets/events/event-image-1.png';
import event2 from '../assets/events/event-image-2.png';
import event3 from '../assets/events/event-image-3.png';

export const EVENTS = [
    {
        image: event1,
        title: 'Omaha Gives',
        description:
            'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Optio hic, sequi voluptates cumque consequatur, expedita saepe similique, assumenda accusamus aliquid tempora laboriosam ullam eligendi corporis est eos praesentium fugit vitae itaque voluptate earum at. Ut.',
    },
    {
        image: event2,
        title: 'Wayne Muller To Speak In Omaha at BFJ Event!',
        description:
            'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Optio hic, sequi voluptates cumque consequatur, expedita saepe similique, assumenda accusamus aliquid tempora laboriosam ullam eligendi corporis est eos praesentium fugit vitae itaque voluptate earum at. Ut.',
    },
    {
        image: event3,
        title: 'Omaha Bread for the Journey - Cabernet For A Cause',
        description:
            'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Optio hic, sequi voluptates cumque consequatur, expedita saepe similique, assumenda accusamus aliquid tempora laboriosam ullam eligendi corporis est eos praesentium fugit vitae itaque voluptate earum at. Ut.',
    },
];
